<!-- 城市详情 -->
<template>
  <div class="city">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
      <el-button @click="is_shai = !is_shai">筛选</el-button>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="gender" label="性别"></el-table-column>
        <el-table-column prop="age" label="年龄"></el-table-column>
        <el-table-column
          prop="education_background"
          label="学历"
        ></el-table-column>
        <el-table-column prop="" label="期望职位">
          <template slot-scope="scope">
            {{ scope.row.position_name.third_position_name || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机"></el-table-column>
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">
            {{ time(scope.row.create_time * 1000) || "" }}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间">
          <template slot-scope="scope">
            {{ time(scope.row.update_time * 1000) || "" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pagesize"
        :current-page.sync="currentPage1"
      ></el-pagination>
    </div>
    <el-dialog
      title="筛选"
      :visible.sync="is_shai"
      width="30%"
      :before-close="
        () => {
          is_shai = false;
        }
      "
    >
      <el-form
        :model="form"
        style="width: 80%; margin: auto"
        label-width="80px"
      >
        <el-form-item label="姓名">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-input v-model="form.gender"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="学历">
          <el-select
            v-model="form.education_background"
            placeholder="请选择学历"
          >
            <el-option label="初中" value="初中"> </el-option>
            <el-option label="高中" value="高中"> </el-option>
            <el-option label="大专" value="大专"> </el-option>
            <el-option label="本科" value="本科"> </el-option>
            <el-option label="硕士" value="硕士"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="期望职位">
          <el-cascader
            style="width: 100%"
            v-model="valueId"
            :props="indus_props"
            :options="zhi_wei"
            @change="
              () => {
                form.position_id = valueId[valueId.length - 1];
              }
            "
          ></el-cascader>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          @click="
            () => {
              index = 0;
              form = {};
              valueId = [];
            }
          "
          >清 空</el-button
        >
        <el-button @click="is_shai = false">取 消</el-button>
        <el-button type="primary" @click="shaiYes">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from "@/utils/http_request.js";
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      title: [],
      loading: false,
      pagesize: 15,
      currentPage1: 1,
      is_shai: false,
      form: {},
      total: 0,
      index: 0,
      zhi_wei: [],
      indus_props: {
        value: "position_id",
        label: "position_name",
        children: "children",
      },
      valueId: [],
    };
  },
  created() {
    this.list();
    axios.get("../static/json/zhiWei.json").then((res) => {
      console.log(res);
      this.zhi_wei = res;
    });
  },

  methods: {
    time(timestamp) {
      function add0(m) {
        return m < 10 ? "0" + m : m;
      }
      //时间戳转化成时间格式
      //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
      var time = new Date(timestamp);
      var year = time.getFullYear();
      var month = time.getMonth() + 1;
      var date = time.getDate();
      var hours = time.getHours();
      var minutes = time.getMinutes();
      var seconds = time.getSeconds();
      return year + "-" + add0(month) + "-" + add0(date);
    },
    shaiYes(e, isFan) {
      console.log(isFan);
      this.index = 1;
      // this.loading = true;
      let obj = {
        // token: this.$cookies.get("token"),
        city_name: this.$route.query.src,
        search_data: this.form,
        page: this.currentPage1 - 1,
      };
      require("post", "/hr24_index_data/v1/resume_city_detail/", obj).then(
        (res) => {
          if (res.code == 0) {
            console.log(res);
            this.tableData = res.data;
            this.loading = false;
            this.is_shai = false;
            this.total = res.resume_count;
            if (!isFan) {
              this.currentPage1 = 1;
            }
            console.log(this.title, this.tableData);
          } else {
          }
        }
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.currentPage1 = val;
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      if (this.index === 1) {
        this.shaiYes(0, "1"); //是否返回第一页
        console.log(val, this.index);
        return;
      } else {
        this.list(val - 1);
      }
    },
    goPage() {
      this.$router.go(-1);
    },
    list(page = 0) {
      let obj = {
        // token: this.$cookies.get("token"),
        city_name: this.$route.query.src,
        search_year:this.$route.query.date, 
        page,
      };
      require("post", "/hr24_index_data/v1/resume_city_detail/", obj).then(
        (res) => {
          if (res.code == 0) {
            console.log(res);
            this.tableData = res.data;
            this.loading = false;
            this.total = res.resume_count;
            console.log(this.title, this.tableData);
          } else {
          }
        }
      );
    }
  }
};
</script>
<style scoped>
/* //@import url(); 引入公共css类 */
.city {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  min-height: 70vh;
  margin-bottom: 20px;
  width: 80vw;

  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
.page {
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/index/city.vue